function SchedulesService($resource, StoresService) {
    const Schedules = $resource('api/schedule/:storeId');

    this.getSchedules = getSchedules;

    function getSchedules() {
        return StoresService.getStore().then(store => Schedules.query({
            storeId: store.storeId
        }).$promise);
    }
}

SchedulesService.$inject = ['$resource', 'StoresService'];

export default SchedulesService;



// WEBPACK FOOTER //
// ./src/js/services/schedules/index.js